import {Question} from './question';
import {AnswerType} from './answer-type';
import {AnswerValue} from './answer-value';

export class RecommendationClause {
  constructor(
    public answerType : AnswerType,
    public valueOperator? : string,
    public value?: AnswerValue,
    public questionOperator?: string,
    public questions?: Question[]
  ) {}

  equals(other : RecommendationClause) : boolean {
    return this.answerType == other.answerType &&
      this.valueOperator == other.valueOperator &&
      this.value.equals(other.value) &&
      this.questionOperator == other.questionOperator &&
      this.questions == other.questions;
  }
  useQuestion(q: Question) : boolean {
    return q &&
      this.questions &&
      this.questions.some(v => v.id == q.id);
  }

  isValid() : boolean {
    return this.answerType &&
      this.valueOperator &&
      this.value &&
      this.questionOperator &&
      this.questions &&
      this.questions.length > 0;
  }
}

export class RecommendationClauseShort {
  constructor(
    public answer_type : string,
    public value_operator : string,
    public value : string,
    public question_operator : string,
    public question_ids : string[]
  ) {}
}



// WEBPACK FOOTER //
// /home/developer/Downloads/SleepRestoreBackend/sleep-restore-boot/src/main/ngapp/src/app/model/recommendation-clause.ts